<template>
  <b-button
    v-b-tooltip.hover.top="tooltip"
    variant="flat-primary"
    size="sm"
    class="quote-log-button"
    :class="{ 'has-notes': count > 0 }"
    :aria-label="ariaLabel"
    @click="open"
  >
    <feather-icon
      icon="MessageSquareIcon"
      size="16"
      aria-hidden="true"
    />
    <span
      v-if="count"
      class="quote-log-button__count"
      aria-hidden="true"
    >{{ count }}</span>
  </b-button>
</template>

<script>
import { BButton, VBTooltip } from 'bootstrap-vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'

const PREVIEW_LENGTH = 90

export default {
  components: {
    BButton,
  },

  directives: {
    'b-tooltip': VBTooltip,
  },

  props: {
    quoteId: {
      type: String,
      required: true,
    },
    folio: {
      type: [String, Number],
      default: null,
    },
  },

  computed: {
    ...mapGetters('quoteNotes', ['summaryFor']),

    summary() {
      return this.summaryFor(this.quoteId)
    },

    count() {
      return this.summary?.count || 0
    },

    tooltip() {
      const last = this.summary?.last
      if (!last) return 'Bitácora: agregar una nota'
      const body = last.body.length > PREVIEW_LENGTH ? `${last.body.slice(0, PREVIEW_LENGTH)}…` : last.body
      return `${last.author_name || 'Equipo'}: ${body}`
    },

    ariaLabel() {
      if (!this.count) return `Abrir bitácora de la cotización ${this.folio || ''}, sin notas`
      return `Abrir bitácora de la cotización ${this.folio || ''}, ${this.count} ${this.count === 1 ? 'nota' : 'notas'}`
    },
  },

  watch: {
    quoteId: {
      immediate: true,
      handler(quoteId) {
        this.queueQuoteNotesSummary(quoteId)
      },
    },
  },

  methods: {
    ...mapActions('quoteNotes', ['queueQuoteNotesSummary']),
    ...mapMutations('quoteNotes', { openPanel: 'OPEN_PANEL' }),

    open() {
      this.openPanel({ quoteId: this.quoteId, folio: this.folio })
    },
  },
}
</script>

<style lang="scss" scoped>
.quote-log-button {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.2rem;
  min-width: 2rem;
  min-height: 2rem;
  padding: 0.3rem 0.45rem;
  color: #6e6b7b;

  &.has-notes {
    color: #340668;
  }

  &:focus-visible {
    outline: 2px solid #340668;
    outline-offset: 2px;
  }
}

.quote-log-button__count {
  font-size: 0.78rem;
  font-weight: 700;
  line-height: 1;
}
</style>
